import { getSignedUpViaID } from "Signups/SharedComponents/getSignedUpViaID";

import {
  convertExtendedFieldInputResponses,
  convertSharedExtendedFieldInputResponses,
} from "./dataTranformations";

export async function composeModifyHouseholdSubmitData({
  state,
  signupItemID,
  householdID,
  respondents,
  extendedFieldInputResponses,
  sharedExtendedFieldInputResponses,
  extendedFields,
}) {
  const selectedRespondents = respondents.filter((r) => r.isChecked);

  // for this we use total number of people (regardless of household or "additional name" status)
  const numberOfSlots = selectedRespondents.length;

  const signedUpViaID = getSignedUpViaID();

  // an array of userIDs of just those that are selected and NOT additional name entries
  const usersToSignup = selectedRespondents
    .filter((r) => !r.isAdditionalName)
    .map((r) => r.userID);

  // an array of strings: just the NEW "additional name" entries that were manually typed in
  // (we use the absense of an additionalNameID to determine that they are new)
  const additionalNames = selectedRespondents
    .filter((r) => r.isAdditionalName)
    .map((r) => r.name);

  const submitData = {
    signupListID: state.currentSignupList.ID,
    signupItemID,
    householdID,
    numberOfSlots,
    signedUpViaID,
    usersToSignup,
    additionalNames,
    extendedFieldInputResponses: await convertExtendedFieldInputResponses(
      extendedFieldInputResponses,
      extendedFields
    ),
    sharedExtendedFieldInputResponses:
      await convertSharedExtendedFieldInputResponses(
        sharedExtendedFieldInputResponses,
        extendedFields
      ),
  };

  return submitData;
}
